<template>
  <div class="container-fluid">
    <div class="row justify-content-md-center">
      <div class="col-md-9 col-xl-7">
        <div class="card-header px-0 mt-2 bg-transparent clearfix">
          <h4 class="float-left pt-2">{{ $t('users.new') }}</h4>
          <div class="card-header-actions mr-1">
            <a dusk="save-button" class="btn btn-primary" href="#" :disabled="submiting" @click.prevent="create">
              <i class="fas fa-spinner fa-spin" v-if="submiting"></i>
              <i class="fas fa-check" v-else></i>
              <span class="ml-1">{{ $t('users.save') }}</span>
            </a>
          </div>
        </div>
        <div class="card-body px-0">
          <div class="form-group">
            <label>{{ $t('users.name') }}</label>
            <input dusk="name-input" type="text" class="form-control" :class="{'is-invalid': errors.name}" v-model="user.name" placeholder="John Doe">
            <div class="invalid-feedback" v-if="errors.name">{{errors.name[0]}}</div>
          </div>
          <div class="form-group">
            <label>{{ $t('users.business_name') }}</label>
            <input type="text" class="form-control" :class="{'is-invalid': errors.business_name}" v-model="user.business_name" placeholder="Company inc.">
            <div class="invalid-feedback" v-if="errors.business_name">{{errors.business_name[0]}}</div>
          </div>
          <div class="form-group">
            <label>{{ $t('users.email') }}</label>
            <input dusk="email-input" type="email" class="form-control" :class="{'is-invalid': errors.email}" v-model="user.email" placeholder="john@modulr.io">
            <div class="invalid-feedback" v-if="errors.email">{{errors.email[0]}}</div>
          </div>
          <div class="form-group">
            <label>{{ $t('users.password') }}</label>
            <input dusk="password-input" type="password" class="form-control" :class="{'is-invalid': errors.password}" v-model="user.password">
            <div class="invalid-feedback" v-if="errors.password">{{errors.password[0]}}</div>
          </div>
          <div class="form-group">
            <label>{{ $t('users.roles') }}</label>
            <multiselect
              dusk="roles-input"
              v-model="user.roles"
              :options="roles"
              :multiple="true"
              openDirection="bottom"
              track-by="id"
              label="display_name"
              :class="{'border border-danger rounded': errors.roles}">
                <template slot="caret">
                   <div class="multiselect__select" dusk="select-tags"></div>
                </template>
                <template slot="option" slot-scope="props">
                   <span :dusk="props.option.name">{{ props.option.name }}</span>
                </template>
            </multiselect>
            <div class="form-group" v-if="isUser(user.roles)">
                <label>{{ $t('users.commercial_ref') }}</label>
                <multiselect
                  v-model="user.commercials"
                  :options="commercials"
                  :multiple="true"
                  openDirection="bottom"
                  track-by="id"
                  label="name"
                  :class="{'border border-danger rounded': errors.commercials}">
                </multiselect>
                <small class="form-text text-danger" v-if="errors.commercials">{{errors.commercials[0]}}</small>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      user: {
            roles: [],
            commercials: [],
            business_name: '',
            password: 'industrial'
      },
      roles: [],
      commercials: [],
      errors: {},
      submiting: false
    }
  },
  mounted () {
    this.getRoles()
  },
  methods: {
    isUser(roles){
      return roles.find(function(el){
         return el.id === 2
      }) != null;
    },
    create () {
      if (!this.submiting) {
        this.submiting = true
        axios.post(`/api/users/store`, this.user)
        .then(response => {
          this.$toasted.global.error(this.$i18n.t('users.created'))
          location.href = '/users'
        })
        .catch(error => {
          this.errors = error.response.data.errors
          this.submiting = false
        })
      }
    },
    getRoles () {
      axios.all([
          axios.get(`/api/roles/all`),
          axios.get('/api/users/getCommercials'),
      ])
      .then(axios.spread((response, commercials) => {
        this.roles = response.data;
        this.commercials = commercials.data;
      }))
      .catch(error => {
        this.errors = error.response.data.errors
      })
    }
  }
}
</script>
